import { render, staticRenderFns } from "./FringeFabricDisclaimer.vue?vue&type=template&id=6840b878&scoped=true&"
import script from "./FringeFabricDisclaimer.vue?vue&type=script&lang=ts&"
export * from "./FringeFabricDisclaimer.vue?vue&type=script&lang=ts&"
import style0 from "./FringeFabricDisclaimer.vue?vue&type=style&index=0&id=6840b878&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6840b878",
  null
  
)

export default component.exports